import React from 'react';
import { useAuth } from '../context/AuthContext';

const Header: React.FC = () => {
  const { user, role, logout } = useAuth();

  const roleClass = `user-role-badge role-${role}`;

  return (
    <header>
      <div className="header-left">
        <img src="/LOFT Logo.png" alt="LOFT Logo" className="header-logo" />
        <div>
          <h1>LOFT</h1>
          <p className="subtitle">Landing Gear Overhaul &amp; Fleet Tracker</p>
        </div>
      </div>
      <div className="header-user">
        <span id="user-email-display">{user?.email || ''}</span>
        <span className={roleClass}>{role}</span>
        <button className="btn btn-secondary btn-sm" onClick={logout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
